import { type KeywordFlaggingDataSource } from '../../data/keyword-flagging.datasource'
import { type KeywordListModel } from '../models/keyword-list.model'

export interface SaveKeywordListParams {
  id?: string
  name: string
  keywords: string[]
  autoModeration: boolean
}

export class SaveKeywordListInteractor {
  constructor(private readonly dataSource: KeywordFlaggingDataSource) {}

  async execute(params: SaveKeywordListParams): Promise<KeywordListModel> {
    const entity = await this.dataSource.save({
      id: params.id,
      name: params.name,
      keywords: params.keywords,
      auto_moderation: params.autoModeration
    })
    return {
      id: entity.id,
      name: entity.name,
      keywords: [...entity.keywords],
      autoModeration: entity.auto_moderation,
      dateModified: new Date(entity.date_modified)
    }
  }
}
